module.exports = __webpack_public_path__ + "img/error1.ff1c67b9.png";